var map = {
	"./font/CentraNo2-Bold.ttf": 8585,
	"./font/CentraNo2-Book.ttf": 358,
	"./font/CentraNo2-Medium.ttf": 3209,
	"./img/CareerOrientation.jpg": 4486,
	"./img/CareerOrientation.webp": 5794,
	"./img/SSO.png": 657,
	"./img/arrow1.svg": 6448,
	"./img/arrow2.svg": 7440,
	"./img/banner-bg.png": 4927,
	"./img/color-sharp.png": 7101,
	"./img/color-sharp2.png": 5640,
	"./img/contact-img.svg": 936,
	"./img/dva.webp": 9783,
	"./img/footer-bg.png": 3758,
	"./img/github.png": 6096,
	"./img/github.svg": 2905,
	"./img/github.webp": 3385,
	"./img/header-img.jpg": 7583,
	"./img/header-img.png": 8958,
	"./img/header-img.svg": 4384,
	"./img/healthkit.webp": 7901,
	"./img/logo.svg": 5522,
	"./img/meter1.svg": 6523,
	"./img/meter2.svg": 7189,
	"./img/meter3.svg": 9059,
	"./img/nav-icon1.svg": 5741,
	"./img/nav-icon2.svg": 4698,
	"./img/nav-icon3.svg": 282,
	"./img/order_food.webp": 2266,
	"./img/pincap.webp": 5966,
	"./img/project-img1.png": 5497,
	"./img/project-img2.png": 5083,
	"./img/project-img3.png": 2955,
	"./img/qr-faceid.webp": 8308,
	"./img/ssoPng.webp": 2715,
	"./skills/Figma.png": 7893,
	"./skills/JavaScript.png": 3239,
	"./skills/JavaScript.webp": 6229,
	"./skills/PostgreSQL.png": 8535,
	"./skills/Postman.png": 2761,
	"./skills/Postman.svg": 9742,
	"./skills/css.png": 170,
	"./skills/css.svg": 6934,
	"./skills/django.png": 4643,
	"./skills/figma (1).png": 9078,
	"./skills/html.png": 923,
	"./skills/python.png": 549,
	"./skills/react.png": 9914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;